import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
          <i className="ri-emotion-sad-line text-3xl text-primary-500"></i>
        </div>
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-3">404</h1>
        <p className="text-foreground-500 text-sm mb-8">抱歉，您访问的页面不存在</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}